export interface AuthState {
  user: any;
}

export const authStateConfig = {
  initState: {
    user: null,
  }
}

export interface LoginDto {
  username: string,
  password: string
}

export interface AuthResponse {
  accessToken: string
}
